import { ApiClientInterface } from './clients';
import { TransactionType } from './enums';
import { FeeSettings } from './models/project/common/FeeSettings';

export class FeeSettingsProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async getOne(transactionType: TransactionType): Promise<FeeSettings> {
    return this.apiClient.get(`/${transactionType}`);
  }
}
